// Token相关工具函数

const TokenKey = 'access_token'
const RefreshTokenKey = 'refresh_token'

// 获取token
export function getToken () {
  return localStorage.getItem(TokenKey)
}

// 设置token
export function setToken (token) {
  localStorage.setItem(TokenKey, token)
}

// 移除token
export function removeToken () {
  localStorage.removeItem(TokenKey)
}

// 获取刷新token
export function getRefreshToken () {
  return localStorage.getItem(RefreshTokenKey)
}

// 设置刷新token
export function setRefreshToken (token) {
  localStorage.setItem(RefreshTokenKey, token)
}

// 移除刷新token
export function removeRefreshToken () {
  localStorage.removeItem(RefreshTokenKey)
}

// 清除所有认证信息
export function clearAuth () {
  removeToken()
  removeRefreshToken()
  localStorage.removeItem('user_info')
  localStorage.removeItem('permissions')
  localStorage.removeItem('roles')
}

// 检查是否已认证
export function isAuthenticated () {
  return !!getToken()
}

// 获取token过期时间
export function getTokenExpiration () {
  const token = getToken()
  if (!token) {
    return null
  }

  try {
    // JWT token的payload部分
    const payload = token.split('.')[1]
    const decoded = JSON.parse(atob(payload))
    return decoded.exp ? decoded.exp * 1000 : null // 转换为毫秒
  } catch (error) {
    console.error('解析token失败:', error)
    return null
  }
}

// 检查token是否即将过期（在指定时间内）
export function isTokenExpiringSoon (thresholdMinutes = 5) {
  const expiration = getTokenExpiration()
  if (!expiration) {
    return true
  }

  const now = Date.now()
  const thresholdMs = thresholdMinutes * 60 * 1000

  return expiration - now <= thresholdMs
}
